// import OwlCarousel from "react-owl-carousel";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Testimonials.css";
import { useContext, useEffect, useState } from "react";
import { LangContext } from "../../../Context/LangContext";
import { REVIEWS, baseURL } from "../../../Api/Api";
import axios from "axios";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const areaDataCache = {};

function SubTestimonial(props) {
  const langCtx = useContext(LangContext);
  return (
    <div className="sub-testimonial" dir={langCtx === "ar" ? "rtl" : "ltr"}>
      <div className="sub-details-testimonial">
        <p>{props.des}</p>
      </div>
      <div className="info-testimonial">
        <div className="img-info-testimonial">
          <img src={props.img} alt={props.name} />
        </div>
        <h2>{props.name}</h2>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const langCtx = useContext(LangContext);
  const [dataReviews, setdataReviews] = useState([]);

  console.log({
    langCtx,
    dataReviews,
  });

  useEffect(() => {
    const fatchData = async (postcode) => {
      if (!areaDataCache[postcode]) {
        const res = await axios.get(`${baseURL}/${REVIEWS}`, {
          headers: {
            Accept: "application/json",
            "Accept-Language": `${langCtx}`,
          },
        });
 
        const data = await res.data.data;
        areaDataCache[postcode] = data;
        setdataReviews(data);
      }
      setdataReviews(areaDataCache[postcode]);
    };
    fatchData(langCtx);
  }, [langCtx]);

  const taFeatures = dataReviews.map((item, index) => {
    return (
      <SwiperSlide >
        <SubTestimonial
          key={index}
          des={item.review}
          name={item.name}
          img={item.photo}
        />
      </SwiperSlide>
    );
  });


  return (
    <section className="testimonials pg-section mr-section" id="customer">
      <div className="main-container">
        <Row className="align-items-center">
          <Col lg={7}>
            <div className="text-testimonials">
              <div className="title-testimonials">
                <h2>
                  <span> # {text.Why[langCtx]}</span> {text.TitleTest[langCtx]}
                </h2>
                <h3> {text.desTitleTest[langCtx]} </h3>
              </div>

              <Swiper
            
                modules={[Navigation, Pagination, A11y]}
                spaceBetween={0}
                slidesPerView={1}
                navigation
                onSwiper={(swiper) => console.log(swiper)}
                onSlideChange={() => console.log("slide change")}
              >
                {taFeatures}
              </Swiper>

  
            </div>
          </Col>
          <Col lg={5}>
            <div className="img-testimonials">
              <img src="/images/imgtestm.png" alt="imgtestimonials" />
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}

const text = {
  TitleTest: {
    ar: "تقوم باختيارنا ؟ ",
    en: "Do you choose us?",
  },
  Why: {
    ar: "لماذا ",
    en: "Why",
  },
  desTitleTest: {
    ar: "أفضل واجهة رسومية من خلال أحدث عرض للتطبيقات ",
    en: "Best graphical interface with latest application display",
  },
};
